import React,{Component} from 'react';

import moment from 'moment';

import Wrapper from '../Wrapper';

import LoadMore from '../LoadMore';

import jump from 'jump.js';

import './Events.less';

class Events extends Component{

  state = {
    type: 'Anstehend',
    pastEvents: [],
    year: moment().year(),
    currentYear: moment().year(),
    yearFilter: false,
    allLoaded: false
  }

  more = () => {
    const {year,allLoaded} = this.state;
    if(allLoaded){
      this.setState({
        action:'close',
        yearFilter:false
      })
    }else{
      this.loadYear(year);
    }

  }

  close = () => {
    const {currentYear} = this.state;
    jump('#' + this.props.id, {
      callback: () => this.setState(
        {
          yearFilter:currentYear,
          action:'more'
        }
      )
    })

  }

  loadYear = (year) => {

    const bitID = this.props.data.social.filter(el => el.network == 'bandsintown')[0].url.replace('https://bandsintown.com/','');
    const {pastEvents,currentYear} = this.state;

    let start = `${year}-01-01`;
    let end = `${year+1}-01-01`;

    if(currentYear == year){
      start =  `${year}-01-01`;
      end = moment().day(0).format('YYYY-MM-DD');
    }

    fetch(`https://rest.bandsintown.com/artists/${bitID}/events?app_id=${bitID}&date=(${start}%2C${end})`)
    .then(res => res.json())
    .then(res => {
      this.setState(
        {
          pastEvents: [...pastEvents,...res.reverse()],
          action: 'more',
          yearFilter: false
        }
      );
      if(!res.length){
        this.setState({
          action: 'close',
          allLoaded: true
        })
      }
    });

    this.setState({
      year: year - 1
    })
  }

  switchType = (type) => {
    const {pastEvents,year} = this.state;


    if(type == 'Vergangen' && !pastEvents.length){
      this.loadYear(year);
    }

    this.setState({
      type
    })
  }

  render(){
    const {res,id,data} = this.props;
    const {type,pastEvents,action,yearFilter,currentYear,allLoaded} = this.state;
    return (
      <Wrapper title="Termine"
      menuItems={['Anstehend', 'Vergangen']}
      menuAction={this.switchType}
      res={res} id={id}>
        <div style={{display:'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between'}}>
        {
          type == 'Anstehend' && data.events.map((event,idx) => <Event key={idx} {...event} res={res}/>)
        }
        {
          type == 'Vergangen' && (
            <div className='past-events-wrapper'>
              <table className='past-events'>
                <tbody>
                  {pastEvents.filter(el => {
                    if(yearFilter){
                      return moment(el.datetime).format('YYYY') == currentYear
                    }else{
                      return el;
                    }
                  }).map((el,idx) => <PastEvent key={idx} {...el} />)}
                </tbody>
              </table>
              <LoadMore action={action == 'more' ? this.more : this.close} type={action}/>
            </div>)
        }
        {/* <Event city="Saalbach" location="wasweißich" date={new Date()} bands={['Me first and the gimme gimmes', 'Blackoutproblems', 'The Hives']} res={res}/> */}
        </div>
      </Wrapper>
    )
  }
}

// const Events = () => {
//   console.log();
//   return
// }

export default Events

const monthNames = ['jan', 'feb', 'mär', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dez'];

const PastEvent = ({datetime,venue}) => {
  const date = moment(datetime);
  return(
    <tr>
      <td>{date.format('DD/MM/YY')}</td>
      <td>{venue.name}</td>
      <td className='past-city'>{venue.city}</td>
    </tr>
  )
}

const Event = (props) => {
  const {url, day, month, city, name, bands,res} = props;
  const monthIndex = parseInt(month.indexOf('0') == 0 ? month.replace('0','') : month);
  const montName = monthNames[monthIndex-1];
  // const day_ = date.getDate();
  // const day = day_ < 10 ? "0" + day_ :  day_;
  return(
    <div className="event">
        <div className="event-date"><span className="event-month">{montName}</span><span className="event-day">{day}</span></div>
        {
          url
          ? (res == 'xlarge' || res == 'large') && <a href={url} target="_blank" className='event-ticket'>Ticket</a>
          : (res == 'xlarge' || res == 'large') && <a href='' className="event-ticket noticket" onClick={e => e.preventDefault()}>Ticket</a>
        }
        <div className="event-city">{city}</div>
        <div className="event-location">{name}</div>
        {
          bands && <div className="event-bands">w/ {bands.join(', ').substring(0,60)}...</div>
        }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/sections/Events.js